/*!
 *
 * components.js
 *
 */


'use strict';

// plugins
require('jquery');
require('jquery.easing');
require('jquery.transit');
require('fancybox')($);
require('jquery-mobile-events');
require('owl.carousel');

// module
require('origin');
var pagetop = require('pagetop');
var linker = require('linker');
var slideScroll = require('slide-scroll');
var phoneCheck = require('phone-check');
require('tab-navigator');
var menu = require('menu');
var mainvis = require('mainvis');
require('fade-contents');
require('following');
require('swipe-elem');
var megamenu = require('megamenu');
require('fit-image');
require('get-filesize');

$(function(){

	$('table.swipe, table.swipe-center, .template-table').swipeElem({
		width: 820
	});
	phoneCheck();
	linker.init({
		extendLink: '.biglink'
	});
	slideScroll({
		speed: 700,
		easing: 'easeOutExpo',
		not: '.not-scroll, .tab a, .tab_head a, #menu_btn a, #search_btn a, .common_tab_01 a, .common_tab_head a'
	});

	$('#header').following({
		pcSticky: '#header',
		spSticky: '#header',
		pcMoveElem: '#global'
	});

	menu.init();
	pagetop.init();

	$('.tab').tabNavigator();
	$('.common_tab_01').tabNavigator({
		head: '.common_tab_head_01',
		offsetClass: '.common_tab_wrapper_01'
	});

	$('a.fancybox').fancybox();

	$('#search_btn a').fancybox({
		padding: 0,
		closeBtn : false,
		minHeight : 0,
		tpl: {
			wrap : '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin fancybox-skin-search"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>'
		}
	});

	megamenu();
	mainvis();

	var $products = $('#products_list'),
		productsOption = {
			loop: true,
			margin: 0,
			navText: ['', ''],
			responsiveClass: false,
			responsive:{
				0:{
					items: 1,
					nav: true,
					dots: true
				},
				540:{
					items: 2,
					nav: true,
					dots: true
				},
				769:{
					items: 7,
					nav: false,
					loop: false,
					dots: false
				}
			}
		};
	if( origin.VPisMobile ){
		$products.owlCarousel(productsOption);
	};
	origin.$window.on('changePC', function(){
		$products.trigger('destroy.owl.carousel');
	}).on('changeMobile', function(){
		$products.owlCarousel(productsOption);
	});

	$('#top_work_gallery').owlCarousel({
		loop: true,
		margin: 0,
		navText: ['', ''],
		responsiveClass: false,
		responsive:{
			0:{
				items: 1,
				nav: true,
				dots: true
			}
		}
	});

	$('#banner_list').owlCarousel({
		loop: true,
		margin: 10,
		navText: ['', ''],
		responsiveClass: false,
		responsive:{
			0:{
				items: 1,
				nav: true
			},
			375:{
				items: 2,
				nav: true
			},
			769: {
				items: 3,
				nav: true
			},
			1080: {
				items: 4,
				nav: true
			}
		}
	});

	$('#message, #product, #about, #cross, #pickup, #news, #banner, #other').fadeContents();

	$('.common_box_figure_center_01 img, .common_box_figure_01 img').fitImages();

	$('.pdf_size').getFileSize();
});



//////////////////
// WEBPACK FOOTER
// ./dev/js/components/app.js
// module id = 0
// module chunks = 0